module.exports = __webpack_public_path__ + "img/android7.0148bc37.jpg";